(function ($, Cobalt, undefined) {
    var windowFocus = true;
    var topCommentPerPage = [];

    Cobalt.NewContent = {
        dependentScripts: function () { return [{ dependency: Cobalt.Listing, name: "Cobalt.Listing" }]; },
        initialize: function () {
            var autoRefresh = $(".j-auto-refresh:checked");
            if (autoRefresh.length > 0) {
                var listingContainer = autoRefresh.parents(".listing-container");

                Cobalt.runOnHtmlInsert(function (elem) {
                    listingContainer = elem.find(".j-auto-refresh:checked").parents(".listing-container");
                });

                $(window).focus(function () {
                    windowFocus = true;
                    Cobalt.NewContent.setPageTitle();
                })
                    .blur(function () {
                        windowFocus = false;
                    });

                setInterval(function () {

                    $.get(Cobalt.Routes.Instance.ForumGetAllForumSeenInfo(), function (data) {
                        if (data.Success) {
                            Cobalt.Forum.ForumSeen = $.parseJSON(data.ForumSeen);
                            Cobalt.Forum.ForumThreadSeen = $.parseJSON(data.ForumThreadSeen);
                            Cobalt.Forum.ForumThreadCommented = $.parseJSON(data.ForumThreadCommented);
                        }
                    });

                    $.ajax(
                    {
                        url: document.location.href,
                        cache: false,
                        headers:
                        {
                            "x-cobalt-listing-url": Cobalt.Listing.CurrentListingUrl
                        },
                        error: function (xhr, status, errorThrown) {
                            listingContainer.unmask();
                        },
                        beforeSend: function () {
                            listingContainer.mask();
                        },
                        success: function (data) {
                            // Insert the new listing in place of the old one
                            var newListing = $(data);
                            var oldListing = listingContainer;
                            var listingParent = oldListing.parent();
                            oldListing.remove();
                            listingParent.append(newListing);
                            Cobalt.triggerHtmlInsert(listingParent);
                        }
                    });
                }, 15000);

                Cobalt.runOnHtmlInsert(Cobalt.NewContent.setPageTitle);
            }

            $("body").on("change", ".j-auto-refresh, .j-mod-view", function (e) {
                $(this).parents("form").submit();
            });


            Cobalt.NewContent.setPageTitle();
        },

        setPageTitle: function () {

            var title = $(document).attr("title");        
            var countRegex = /\(([0-9]+)\+?\)/g;
            var commentView = $(".j-mod-view:checked");
            var pageMax = 15;

            //if the table doesn't exisit the page is displaying comments and a count does not need to be generated.
            if (commentView.length == 0) {

                //If the title already has a count on it remove it.
                title = title.replace(countRegex, "");

                var threadTable = $(".forum-thread-listing");
                var itemCount = threadTable.attr("data-unread-thread-count");
                var maxUnreadCount = threadTable.attr("data-max-unread-thread-count");
                if (itemCount && parseInt(itemCount) > 0) {
                  
                    //If the unread amount is greater then maxUnreadCount account display the maxUnreadCount ex.. (100+)
                    if (parseInt(itemCount) > parseInt(maxUnreadCount)) {
                        title = "(" + maxUnreadCount + "+) " + title;
                    }
                    else {
                        title = "(" + itemCount + ") " + title;
                    }
                }              
            }
            else {

                //Get list of comments
                var comments = $(".p-comment-post");
                var firstCommentDate = 0;
                var commentCount = 0;

                //Need the page the view is on 
                var page = Cobalt.NewContent.getQueryStringValue("page");
                if (!page) {
                    page = 1;
                }

                //If the window is not focused add up the unread values
                if (!windowFocus) {
                    var match = countRegex.exec(title);
                    if (match) {
                        commentCount = parseInt(match[1]);
                    }
                }
                title = title.replace(countRegex, "");

                //loop through comments comparing comment date to the date of top comment on the page. 
                //if the comment date is greater then the top comment date add to the counter.
                for (var i = 0; i < comments.length; i++) {

                    var row = $(comments[i]);
                    var commentDate = parseInt(row.attr("data-comment-date"));

                    //Get top comments date
                    if (i == 0) {
                        firstCommentDate = commentDate;
                    }

                    //break loop if there is no legacy top comment date
                    if (!topCommentPerPage[page]) {
                        break;
                    }

                    if (commentDate > topCommentPerPage[page]) {
                        commentCount++;
                    }
                    else {
                        break;
                    }
                }

                //Save top comments date
                topCommentPerPage[page] = firstCommentDate;

                //If the unread amount is greater then pageMax  display the pageMax ex.. (15+)
                if (parseInt(commentCount) >= parseInt(pageMax)) {
                    title = "(" + pageMax + "+) " + title;
                }
                else {
                    title = "(" + commentCount + ") " + title;
                }
            }

            $(document).attr("title", title);

        },

        getQueryStringValue: function (param) {
            var queries = {};
            $.each(document.location.search.substr(1).split('&'), function (c, q) { var i = q.split('='); queries[i[0].toString()] = i[1].toString(); });

            var val = queries[param];

            return val;
        }

    };

})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.NewContent.js